import { useNavigate } from "react-router-dom";
import { Type } from "@shared/ui/Type";
import { Button } from "@shared/ui/Button";

export type Props = {
  errorMessage: string;
};

export function VideoUIAccessError({ errorMessage }: Props) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] gap-4">
      <Type variant="h4" className="text-red-500">
        Access Denied
      </Type>
      <Type variant="body2" className="text-red-400 text-center max-w-md">
        {errorMessage}
      </Type>
      <Button onClick={() => navigate("/dashboard")} variant="secondary">
        Back to Dashboard
      </Button>
    </div>
  );
}

export default VideoUIAccessError;
